import * as React from "react";
import FormControl from "@mui/material/FormControl";
import { Box, TextField, Autocomplete } from "@mui/material";
import { useRecoilState } from "recoil";
import { auditFilterAtom, staticDataAtom } from "../../atoms/atoms";

export default function PharmacyFilter({ data }) {
  const [staticData, setStaticData] = useRecoilState(staticDataAtom);
  const [filterOptions, setFilterOptions] = useRecoilState(auditFilterAtom);

  // Debug to see what's in staticData
  console.log("Encounter Pharmacies:", staticData.pharmacies);

  const handleChange = (event, values) => {
    setFilterOptions((prev) => ({
      ...prev,
      pharmacy_names: values,
    }));
  };

  // Create sorted pharmacy list with safety checks
  const pharmacyOptions = React.useMemo(() => {
    if (!staticData?.pharmacies || staticData.pharmacies.length === 0) {
      console.log("No encounter pharmacies available");
      return [];
    }

    // Create a new sorted array
    const sorted = [...staticData.pharmacies].sort((a, b) => {
      // Add null/undefined checks for safety
      if (!a && !b) return 0;
      if (!a) return 1;
      if (!b) return -1;
      return a.localeCompare(b);
    });

    console.log("Sorted encounter pharmacies:", sorted);
    return sorted;
  }, [staticData.pharmacies]);

  return (
    <Box className="filterBar">
      <FormControl sx={{ m: 1, minWidth: 165, p: 1 }}>
        <Autocomplete
          multiple
          value={filterOptions.pharmacy_names || []}
          onChange={handleChange}
          id="checkboxes-tags-demo"
          options={pharmacyOptions}
          getOptionLabel={(option) => option || ""}
          style={{ width: 250, background: "whitesmoke" }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Pharmacies"
              placeholder={
                pharmacyOptions.length === 0 ? "Loading..." : "Pharmacies"
              }
            />
          )}
          disabled={pharmacyOptions.length === 0}
        />
      </FormControl>
    </Box>
  );
}
